import { downloadsData } from './pages';

export const bannerSlides = [
  {
    id: 1,
    title: '新译 NEWTRANX',
    subtitle: '全球 AI 智能翻译硬件服务商',
    tag: 'AI 全场景智能翻译硬件',
    description: 'MossTeams 政企会议硬件 — 离线同传 · 私有化部署 · 140+ 语种覆盖',
    ctaText: '了解 MossTeams',
    ctaLink: '/mossteams/dual-screen',
    ctaSecondary: '申请试用',
    ctaSecondaryLink: '#consultation',
    bgImage: '/images/banner/banner-1-bg.jpg',
    productImage: '/images/banner/banner-1.png',
    imageQuery: 'MossTeams dual screen AI conference translation device on modern meeting table with live multilingual subtitles displayed, professional government conference room with Chinese officials, offline simultaneous interpretation hardware, sleek corporate technology, warm neutral office tones, clean professional product photography',
  },
  {
    id: 2,
    title: 'MossTalk 随身翻译系列',
    subtitle: '您的随身 AI 翻译官',
    tag: '140+ 语种 · 商旅随身',
    description: '指环翻译机 · 降噪翻译耳机 — 出境商旅、外语交流、跨境沟通无缝畅聊',
    ctaText: '了解 MossTalk',
    ctaLink: '/mosstalk/standard',
    ctaSecondary: '去购买',
    ctaSecondaryLink: 'https://shop.m.jd.com/shop/home?shopId=13063638&utm_source=pdappwakeupup_20170002',
    bgImage: '/images/banner/banner-2-bg.jpg',
    productImage: '/images/banner/banner-2.png',
    imageQuery: 'MossTalk ring shaped AI translator device worn on finger showing real time Chinese English translation on smartphone screen, traveler at international airport departure lounge, compact portable translation gadget, modern lifestyle product photography, clean warm natural lighting, premium aesthetic',
  },
  {
    id: 3,
    title: 'MossVox 智能字幕',
    subtitle: '工作 · 学习 · 娱乐的智能字幕助手',
    tag: 'AI 字幕 · 速记 · 配音',
    description: '字幕精灵 Pro + 录音牌 — 影音字幕、会议速记、自媒体出海一站式平台',
    ctaText: '了解 MossVox',
    ctaLink: '/mossvox/subtitle-pro',
    ctaSecondary: '免费注册试用',
    ctaSecondaryLink: 'https://www.mossvox.com',
    bgImage: '/images/banner/banner-3-bg.jpg',
    productImage: '/images/banner/banner-3.png',
    imageQuery: 'MossVox floating translation subtitles overlay on laptop screen during international video conference call, AI powered real time speech to text captions software, content creator modern workspace studio setup, clean minimal aesthetic, warm natural lighting, professional productivity environment',
  },
];

export const productNavCards = [
  {
    id: 'dual-screen',
    title: '智能会议双屏机',
    series: 'MossTeams',
    desc: '会议室专属AI秘书',
    href: '/mossteams/dual-screen',
    imageSrc: '/images/home/dual-screen.jpg',
    imageQuery: 'MossTeams dual screen conference translation terminal with two 15.6 inch touch displays on modern meeting table showing bilingual subtitles, AI meeting secretary hardware, professional corporate boardroom, clean product photography on white background, warm neutral tones, minimalist design',
  },
  {
    id: 'desktop-client',
    title: '桌面客户端',
    series: 'MossTeams',
    desc: '会议一体机桌面搭档',
    href: '/mossteams/desktop-client',
    imageSrc: '/images/home/desktop-client.jpg',
    imageQuery: 'MossTeams desktop translation client software interface on laptop screen showing real time multilingual meeting subtitles and AI generated notes panel, modern workspace setup with dual monitors, professional desktop environment, clean UI design with warm accent colors, soft office lighting',
  },
  {
    id: 'standard-translator',
    title: '指环翻译机',
    series: 'MossTalk',
    desc: '140+语种随身翻译官',
    href: '/mosstalk/standard',
    imageSrc: '/images/home/standard-translator.jpg',
    imageQuery: 'MossTalk Pro ring shaped AI translator device in three colors black silver rose gold arranged on clean white surface, compact finger ring translator gadget for travel, sleek modern design, minimalist product photography, soft studio lighting, premium consumer electronics aesthetic',
  },
  {
    id: 'earbuds',
    title: '翻译耳机',
    series: 'MossTalk',
    desc: '降噪通话翻译耳机',
    href: '/mosstalk/earbuds',
    imageSrc: '/images/home/earbuds.jpg',
    imageQuery: 'MossTalk translation earbuds with open ear design and charging case, wireless ANC noise cancelling translator earphones, clean white background product photography, modern wearable tech accessory for cross language communication, soft studio lighting, minimalist aesthetic',
  },
  {
    id: 'subtitle-pro',
    title: '字幕精灵 Pro',
    series: 'MossVox',
    desc: 'AI智能字幕助手',
    href: '/mossvox/subtitle-pro',
    imageSrc: '/images/home/subtitle-pro.jpg',
    imageQuery: 'MossVox subtitle pro software interface on laptop displaying real time floating translation captions during Zoom video conference, AI powered speech to text multilingual subtitles, modern clean UI design with warm and neutral accent colors, professional digital workspace photography',
  },
  {
    id: 'recorder',
    title: '录音牌',
    series: 'MossVox',
    desc: '高清拾音录音硬件',
    href: '/mossvox/recorder',
    imageSrc: '/images/home/recorder.jpg',
    imageQuery: 'MossVox compact voice recorder hardware device next to smartphone showing call recording transcription, AI speech to text recorder gadget, minimalist hardware design on clean surface, professional product photography, studio lighting, warm neutral white finish',
  },
];

export const coreAdvantages = [
  {
    icon: 'ri-cpu-line',
    title: '自研三重AI引擎',
    desc: 'ASR语音识别 + MT机器翻译 + LLM大语言模型全链路自研，翻译准确率行业领先',
  },
  {
    icon: 'ri-global-line',
    title: '140+语种全球覆盖',
    desc: '覆盖200+国家与地区，支持主流语种及小语种互译，满足全球化沟通需求',
  },
  {
    icon: 'ri-shield-check-line',
    title: '国产化硬件自主可控',
    desc: '核心芯片与硬件全国产化，GPU/NPU算力自主，满足涉密场景安全需求',
  },
  {
    icon: 'ri-lock-line',
    title: '离线保密算力',
    desc: '离线多模态大模型独立运行，数据本地化不联网，军工级信息安全保障',
  },
  {
    icon: 'ri-links-line',
    title: '软硬件全生态联动',
    desc: '双屏机 + 桌面端 + 离线盒子 + 翻译机 + 字幕软件，全系列无缝协同',
  },
];

export const applicationScenarios = [
  {
    id: 'government',
    icon: 'ri-government-line',
    title: '政企会议',
    desc: '离线保密同传、本地私有化部署，满足军政单位涉密会议需求，支持多点字幕投屏、AI会议纪要自动生成',
    products: ['MossTeams 双屏机', '离线语音盒子', '桌面客户端'],
    productLinks: ['/mossteams/dual-screen', '/mossteams/offline-voice-box', '/mossteams/desktop-client'],
    imageSrc: '/images/home/government.jpg',
    imageQuery: 'Chinese government officials in formal conference room using MossTeams dual screen AI translation device for classified meeting, offline simultaneous interpretation hardware on table with multilingual captions displayed, secure private deployment translation technology, professional solemn atmosphere, clean neutral tones',
  },
  {
    id: 'business',
    icon: 'ri-suitcase-line',
    title: '跨境商旅',
    desc: '随身翻译机 + 降噪翻译耳机，出境旅游、海外出差、跨国洽谈实时翻译，140+语种全球畅聊',
    products: ['MossTalk 标准款', 'MossTalk 商务款', '翻译耳机'],
    productLinks: ['/mosstalk/standard', '/mosstalk/business', '/mosstalk/earbuds'],
    imageSrc: '/images/home/business.jpg',
    imageQuery: 'International business traveler using MossTalk ring translator device and translation earbuds at modern airport terminal, real time language translation on smartphone app, cross border communication gadget, sleek portable tech, lifestyle photography, clean natural lighting, global travel concept',
  },
  {
    id: 'education',
    icon: 'ri-book-open-line',
    title: '外语学习',
    desc: '课堂会议双屏机辅助教学、字幕精灵外语影音自学、翻译机日常外语交流练习，多场景语言学习',
    products: ['字幕精灵 Pro', 'MossTalk 翻译机', 'MossTeams 双屏机'],
    productLinks: ['/mossvox/subtitle-pro', '/mosstalk/standard', '/mossteams/dual-screen'],
    imageSrc: '/images/home/education.jpg',
    imageQuery: 'University foreign language classroom with MossTeams dual screen translation device on desk showing bilingual subtitles, students practicing language with MossTalk ring translators, MossVox subtitle pro floating captions on laptop, modern educational technology environment, bright clean setting, warm academic atmosphere',
  },
  {
    id: 'creator',
    icon: 'ri-live-line',
    title: '自媒体出海',
    desc: '字幕精灵Pro一键多语字幕、AI配音、录音牌高清收音，助力短视频创作者低成本内容出海',
    products: ['字幕精灵 Pro', 'MossVox 录音牌', 'MossTalk 翻译机'],
    productLinks: ['/mossvox/subtitle-pro', '/mossvox/recorder', '/mosstalk/standard'],
    imageSrc: '/images/home/creator.jpg',
    imageQuery: 'Chinese content creator studio with MossVox subtitle pro AI multilingual captioning software on large monitor editing short video, MossVox recorder device for high quality audio capture, creator workspace for international social media, modern warm studio lighting, professional creative environment, clean aesthetic',
  },
];

export const customerCases = [
  {
    id: 1,
    company: '某大型央企信息化部',
    logo: 'N',
    category: '政企案例',
    scene: '涉密会议同传',
    product: 'MossTeams 双屏机 + 离线语音盒子',
    desc: '部署离线同传系统覆盖全国30+分支机构，实现涉密会议100%离线翻译，年均支撑会议超2000场',
  },
  {
    id: 2,
    company: '北京外国语大学',
    logo: 'U',
    category: '高校教育案例',
    scene: '多语种教学实训',
    product: 'MossTeams 双屏机 + MossTalk 标准款',
    desc: '引入AI翻译硬件辅助多语种教学，学生在课堂实时体验140+语种互译，教学效率提升显著',
  },
  {
    id: 3,
    company: '深圳市跨境贸易协会',
    logo: 'T',
    category: '外贸企业案例',
    scene: '跨国商务洽谈',
    product: 'MossTalk 商务款 + 翻译耳机',
    desc: '为会员企业配备商务翻译设备，支撑300+外贸企业跨境会议、海外展会实时翻译需求',
  },
  {
    id: 4,
    company: '某百万粉丝海外博主',
    logo: 'C',
    category: '自媒体个人案例',
    scene: '多语种字幕创作',
    product: 'MossVox 字幕精灵 Pro',
    desc: '使用AI字幕+配音功能，将中文视频一键生成多语种版本，海外平台播放量增长超500%',
  },
];

export const newProducts = [
  {
    id: 'offline-box',
    title: '离线语音盒子',
    subtitle: 'AI语音算力核心 · 离线多模态大模型',
    tag: '新品上市',
    desc: '搭载离线ASR/MT/LLM/TTS全链路引擎，无网环境独立运行，为全系列Moss产品提供底层翻译算力，主打军队、涉密政企场景。',
    features: ['离线全链路引擎', '30+语种识别', '毫秒级响应', '全接口拓展'],
    href: '/mossteams/offline-voice-box',
    imageSrc: '/images/home/new-1.jpg',
    imageQuery: 'MossTeams offline voice computing box hardware with sleek dark metal industrial design, standalone AI translation processing unit for secure air gapped environments, military grade offline speech recognition engine, compact server grade computing device, clean product photography on gradient background, blue LED accent lighting, professional military tech aesthetic',
  },
  {
    id: 'business-translator',
    title: 'MossTalk 商务款',
    subtitle: '商务专属AI翻译 · 会议纪要+思维导图',
    tag: '新品推荐',
    desc: '在标准款全功能基础上，新增AI会议总结、思维导图生成、跨语言群组聊天、大模型AI问答等专属商务功能。',
    features: ['AI会议总结', '思维导图生成', '跨语言群聊', '耳机同传播报'],
    href: '/mosstalk/business',
    imageSrc: '/images/home/new-2.jpg',
    imageQuery: 'MossTalk business edition premium translator device in titanium grey finish on executive desk next to laptop showing AI generated meeting summary and mind map, professional business setting with documents and coffee, luxury tech gadget for cross border negotiations, clean product photography, warm executive lighting, blue and gold accents',
  },
];

// 首页快捷下载：只维护要展示的条目 key，其余数据（标题/图标/类型/链接）全部来自下载中心 downloadsData。
const quickDownloadKeys = [
  'mossteams-client-win',
  'mossteams-client-mac',
  'mosstalk-standard-manual',
  'mossvox-pro-win',
  'mossvox-pro-mac',
  'mossvox-plugin-chrome',
  'mossvox-recorder-manual',
];

const allDownloadItems = downloadsData.categories.flatMap((cat) => cat.items);

export const quickDownloads = quickDownloadKeys.map((key, idx) => {
  const item = allDownloadItems.find((i) => 'key' in i && (i as { key?: string }).key === key) as
    | { icon?: string; name: string; size: string; type: string; url: string }
    | undefined;
  return {
    id: idx + 1,
    title: item?.name ?? '',
    icon: item?.icon ?? 'ri-file-line',
    type: item?.type ?? '',
    size: item?.size || item?.type || '',
    url: item?.url ?? '',
  };
});

export const companyInfo = {
  name: '新译信息科技（北京）有限公司',
  nameEn: 'Newtranx Information Technology (Beijing) Co., Ltd.',
  address: '北京市通州区世界侨商中心2号楼17层',
  addressBeijing: '北京市（地址预留）',
  serviceHotline: '400-097-5066',
  serviceTime: '9:00-19:00',
  tel: '0755-86529976',
  marketingEmail: 'service02@newtranx.com',
  website: 'https://www.newtranx.com',
  mossvoxWebsite: 'https://www.mossvox.com',
};